import { gql } from '@apollo/client';
import { STUDENT_ASSESSMENT_TOOL_GRADE_DTO_FIELDS } from "./student-assessment-tool-grade";
export const EXAM_CALL_GRADES_TABLE_FIELDS = gql`
  ${STUDENT_ASSESSMENT_TOOL_GRADE_DTO_FIELDS}
  fragment ExamCallGradesTableRow on ExamCallGradesTableRowDto {
    studentId
    studentName
    studentAssessmentToolGrades {
      ...StudentAssessmentToolGrade
    }
    examCallEnrollmentId
    autoGrade
    finalGrade
    finalGradeLocked
  }
`;